import React from "react";
import saree from "../images/saree.jpg";
import kurti from "../images/kurti.jpg";
import suit from "../images/suit.jpg";

function Collection() {
  return (
    <div className="collection">
      <h2>Our Collections</h2>
      <div className="cards">
        <div className="card">
          <img src={saree} alt="Sarees" />
          <h3>Designer Sarees</h3>
        </div>
        <div className="card">
          <img src={kurti} alt="Kurtis" />
          <h3>Stylish Kurtis</h3>
        </div>
        <div className="card">
          <img src={suit} alt="Suits" />
          <h3>Party Wear Suits</h3>
        </div>
      </div>
    </div>
  );
}

export default Collection;
